import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import AffiliateForm from './componants/Staff/AffiliateForm';
import CustomerForm from './componants/Customer/CustomerForm';
import CustomerIndex from './componants/Customer/CustomerIndex';
import Login from './componants/Login/Login';
import Dashboard from './componants/Dashboard/Dashboard';
import AffiliateIndex from './componants/Staff/AffiliateIndex';
import ForgotPassword from './componants/Login/ForgotPassword';
import Otp from './componants/Login/Otp';
import ResetPassword from './componants/Login/ResetPassword';
import LeadsForm from './componants/Leads/LeadsForm';
import LeadsIndex from './componants/Leads/LeadsIndex';
import ClientIndex from './componants/Client/ClientIndex';
import ConverttoClientForm from './componants/Client/ConverttoClient';
import ClientForm from './componants/Client/ClientForm';
import BlogIndex from './componants/Blog/BlogIndex';
import BlogForm from './componants/Blog/BlogForm';
import SignUp from './componants/SignUp/SignUp';
import BusinessForm from './componants/BusinessForm/BusinessForm';
import Vcard from './componants/BusinessForm/Vcard';
import BusinessIndex from './componants/BusinessForm/BusinessIndex';
import Layout from './Layout';
import ClientEdit from './componants/Client/ClientEdit';
import UpdatePassword from './componants/Login/UpdatePassword';
import Settings from './componants/Settings/Settings.js';
import Staff from './componants/Staffs/Staff';
import StaffIndex from './componants/Staffs/StaffIndex';
import { UserProvider } from "./context/UserContext";

const App = () => (
  <UserProvider>
    <Router>
      <Routes>
        <Route path="/" element={<Login />} />
        <Route path="/forgotpassword" element={<ForgotPassword />} />
        <Route path="/otp" element={<Otp />} />
        <Route path="/resetpassword" element={<ResetPassword />} />
        <Route path="/signup" element={<SignUp />} />
        <Route path="/updatepassword" element={<UpdatePassword />} />
        <Route path="/staff" element={<Layout><StaffIndex /></Layout>} />
        <Route path="/staff/create" element={<Layout><Staff /></Layout>} />
        <Route path="/staff/update/:id" element={<Layout><Staff /></Layout>} />
        <Route path="/setting" element={<Layout><Settings /></Layout>}  />
        <Route path="/vcard/:name" element={<Vcard />} />
        <Route path="/dashboard" element={<Layout><Dashboard /></Layout>} />
        <Route path="/affilate" element={<Layout><AffiliateIndex /></Layout>} />
        <Route path="/affilate/create" element={<Layout><AffiliateForm /></Layout>} />
        <Route path="/staff/update/:id" element={<Layout><AffiliateForm /></Layout>} />
        <Route path="/leads/create" element={<Layout><LeadsForm /></Layout>} />
        <Route path="/leads" element={<Layout><LeadsIndex /></Layout>} />
        <Route path="/lead/update/:id" element={<Layout><LeadsForm /></Layout>} />
        <Route path="/client" element={<Layout><ClientIndex /></Layout>} />
        <Route path="/client/update/:id" element={<Layout><ClientEdit /></Layout>} />
        <Route path="/converttoclient/:id" element={<Layout><ConverttoClientForm /></Layout>} />
        <Route path="/client/create" element={<Layout><ClientForm /></Layout>} />
        <Route path="/blogs" element={<Layout><BlogIndex /></Layout>} />
        <Route path="/blogs/create" element={<Layout><BlogForm /></Layout>} />
        <Route path="/vcards" element={<Layout><BusinessIndex /></Layout>} />
        <Route path="/business/create" element={<Layout><BusinessForm /></Layout>} />
        <Route path="/business/update/:id" element={<Layout><BusinessForm /></Layout>} />
        <Route path="/business" element={<Layout><BusinessForm /></Layout>} />
        <Route path="*" element={<Navigate to="/" />} />
      </Routes>
    </Router>
  </UserProvider>
);

export default App;
